import { ImageSource } from "../../gallery/gallery_image";

export class ImageManager {
  private loadedUrls = new Map<string, ImageSource>();

  setSourceLoaded(source: ImageSource) {
    const { url } = source;
    if (isDataUrl(url)) return;
    this.loadedUrls.set(url, source);
  }

  isLoaded(source: ImageSource): boolean {
    const { url } = source;
    if (isDataUrl(url)) return true;

    return this.loadedUrls.has(url);
  }
}

function isDataUrl(url: string) {
  return url.startsWith("data:");
}

export const imageManager = new ImageManager();
